import {
  SortableContainer,
  SortableElement,
} from '@alexcheuk/react-sortable-hoc'

import { SortableTagsContainerStyled } from './styles/SortableTagsContainerStyled'
import { type SortableTagsCommonProps } from '../../types'

const SortableItem = SortableElement(({ children }) => children)

const SortableList = SortableContainer(({ children }) => <div>{children}</div>)

export const SortableTagsContainer = ({
  ...commonProps
}: SortableTagsCommonProps) => {
  const {
    sortableTagsProps: { tags, layout, components },
  } = commonProps

  return (
    <SortableTagsContainerStyled layout={layout}>
      <SortableList
        useDragHandle={true}
        onSortStart={(_, e) => e.preventDefault()}
        onSortEnd={commonProps.onSort}
        lockAxis={
          commonProps.sortableTagsProps.layout === 'xy'
            ? null
            : commonProps.sortableTagsProps.layout
        }
        axis={commonProps.sortableTagsProps.layout}
      >
        {tags.map((tag, index) => (
          <SortableItem key={`item-${index}`} index={index}>
            <components.TagItem
              {...commonProps}
              innerProps={{
                value: tag.value,
                sortIndex: index,
              }}
            />
          </SortableItem>
        ))}
      </SortableList>
    </SortableTagsContainerStyled>
  )
}

SortableTagsContainer.displayName = 'SortableTagsContainer'
